// @ts-nocheck
import { isNaN } from 'lodash'
import SparkMD5 from 'spark-md5'

export default {
  fileToBase64(file: any) {
    return new Promise(function(resolve, reject) {
      let blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice
      var reader = new FileReader()
      reader.onload = function(e) {
        const base64 = btoa(
          String.fromCharCode(...new Uint8Array(e.target.result))
        )
        resolve(base64)
      }
      reader.onerror = function(error) {
        reject(error)
      }
      reader.readAsArrayBuffer(blobSlice.call(file, 0, 63))
    })
  },
  uint8ToBase64(uint8Array) {
    let binary = ''
    uint8Array.forEach(value => {
      binary += String.fromCharCode(value)
    })
    return btoa(binary)
  },

  getFileMd5(file, chunkSize) {
    return new Promise((resolve, reject) => {
      let blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice
      let chunks = Math.ceil(file.size / chunkSize)
      let currentChunk = 0
      let spark = new SparkMD5.ArrayBuffer()
      let fileReader = new FileReader()

      fileReader.onload = function(e) {
        spark.append(e.target.result)
        currentChunk++
        if (currentChunk < chunks) {
          loadNext()
        } else {
          let md5 = spark.end()
          resolve(md5)
        }
      }
      fileReader.onerror = function(e) {
        reject(e)
      }

      function loadNext() {
        let start = currentChunk * chunkSize
        let end = start + chunkSize
        if (end > file.size) {
          end = file.size
        }
        fileReader.readAsArrayBuffer(blobSlice.call(file, start, end))
      }
      loadNext()
    })
  },
  getFileBase64(file) {
    return new Promise((resolve, reject) => {
      let reader = new FileReader()
      // 读取文件的前64个字节
      const byteOffset = 0
      const byteLength = 64
      const blobSlice = file.slice(byteOffset, byteOffset + byteLength)
      reader.readAsArrayBuffer(blobSlice)
      reader.onload = e => {
        const arrayBuffer = e.target.result
        // 将ArrayBuffer转换为Uint8Array
        const uint8Array = new Uint8Array(arrayBuffer)
        // 将Uint8Array转换为Base64编码
        const base64String = this.uint8ToBase64(uint8Array)
        resolve({
          is_success: true,
          data: base64String,
        })
      }
      reader.onerror = e => {
        reject({
          is_success: false,
          data: e,
        })
      }
    })
  },
}
